import React from "react";
import "./styles.css";
import AppRoutes from "./routes/AppRoutes";

export default function App() {
  return (
    <AppRoutes />
  );
}
